/* global $ */
import { Component } from 'preact';
import { Text, withText } from 'preact-i18n';
// jQuery plugin - loaded via jQueryPluginsLoader Vite plugin (see vite.config.js)
import 'item-quantity-dropdown/lib/item-quantity-dropdown.min';
import ChildAgeSelect from './ChildAgeSelect';

class OccupancyPicker extends Component {
  constructor(props) {
    super(props);

    this.handleGuestChange = this.handleGuestChange.bind(this);
    this.handleAgeChange = this.handleAgeChange.bind(this);
  }

  componentDidMount() {
    const { selector_guest, selector_guests } = this.props;
    const $input = $(this.iqDropdownEl);
    const $ageSelect = $input.find('.age-select');
    $ageSelect.click(e => e.stopPropagation());

    $input.iqDropdown({
      maxItems: 20,
      minItems: 1,
      selectionText: selector_guest,
      textPlural: selector_guests,
      onChange: this.handleGuestChange,
      beforeDecrement: (id, itemCount) => {
        const { adult } = itemCount;
        if (id === 'adult') return adult > 1;
        return true;
      },
      beforeIncrement: (id, itemCount) => {
        const { children, adult } = itemCount;
        if (id === 'children') return children < 6;

        if (id === 'adult') return adult < 14;

        return true;
      },
    });
  }

  handleAgeChange(e, index) {
    const { guests, onChange } = this.props;
    const { adult, children } = guests;
    const newArray = [...children];
    newArray[index] = Number(e.target.value);

    onChange({ adult, children: newArray });
  }

  handleChildrenChange(quantity) {
    const { guests, onChange } = this.props;
    const { adult, children } = guests;

    if (quantity > children.length) {
      children.push(0);
    } else if (quantity < children.length) {
      children.pop();
    }

    onChange({ adult, children });
  }

  handleGuestChange(type, quantity) {
    const { guests, onChange } = this.props;
    const { children } = guests;

    if (type === 'adult') {
      onChange({ adult: quantity, children });
      return;
    }

    this.handleChildrenChange(quantity);
  }

  render() {
    const {
      guests,
      label_adults,
      label_minor,
      text_adult_description,
      text_minor_description,
      button_close,
    } = this.props;
    const { adult, children: childrenAges } = guests;

    return (
      <div className="iqdropdown" ref={el => (this.iqDropdownEl = el)}>
        <p className="iqdropdown-selection" />
        <div className="iqdropdown-menu">
          <div
            className="iqdropdown-menu-option"
            data-id="adult"
            data-defaultcount={adult}
            data-mincount="1"
          >
            <div>
              <p className="iqdropdown-item">{label_adults}</p>
              <p className="iqdropdown-description">{text_adult_description}</p>
            </div>
          </div>

          <div
            className="iqdropdown-menu-option"
            data-id="children"
            data-defaultcount={childrenAges.length}
          >
            <div>
              <p className="iqdropdown-item">{label_minor}</p>
              <p className="iqdropdown-description">{text_minor_description}</p>
            </div>
          </div>

          <div className="iqdropdown-row">
            <ChildAgeSelect ages={childrenAges} onAgeChange={this.handleAgeChange} />
          </div>

          <button type="button" className="iqdropdown-menu-close">
            {button_close}
          </button>
        </div>
      </div>
    );
  }
}

export default withText(() => ({
  selector_guest: <Text id="selector.guest" />,
  selector_guests: <Text id="selector.guests" />,
  label_adults: <Text id="label.adults" />,
  label_minor: <Text id="label.minor" />,
  text_adult_description: <Text id="text.adult_description" fields={{ years_old: 18 }} />,
  text_minor_description: (
    <Text id="text.minor_description" fields={{ younger_age: 0, older_age: 17 }} />
  ),
  button_close: <Text id="button.close" />,
}))(OccupancyPicker);
